import { render, staticRenderFns } from "./ProducerData.vue?vue&type=template&id=23abae46&"
import script from "./ProducerData.vue?vue&type=script&lang=js&"
export * from "./ProducerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports